interface JsonViewProps {
  value: unknown;
  emptyMessage?: string;
}

export function JsonView({ value, emptyMessage = "No data yet." }: JsonViewProps) {
  if (value === null || value === undefined) {
    return (
      <div className="rounded-xl border border-border bg-panel p-3 md:p-4 text-sm text-muted">
        {emptyMessage}
      </div>
    );
  }

  return (
    <pre className="overflow-auto rounded-xl border border-border bg-panel p-3 md:p-4 text-[0.65rem] md:text-xs leading-relaxed text-muted">
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}
